module.exports = __webpack_public_path__ + "assets/img/btn-view-e0cdb296.png";